<template>
  <div class="app-voucher-input">
    <slot name="txtBefore">
      <h2 class="uppercase">Guthabenkarte einlösen</h2>
      <p>
        Laden Sie Ihre mobil <span class="uppercase"><abbr title="Subscriber Identity Module">Sim</abbr></span>-Karte einfach und bequem mit mobil Guthabenkarten auf!<br>
        Guthabenkarten sind im Wert von 10 <abbr title="Euro">€</abbr>, 25 <abbr title="Euro">€</abbr> und 50 <abbr title="Euro">€</abbr> in allen Filialen erhältlich.
      </p>
    </slot>
    <b-form>
      <b-form-group
        label="Code einlösen"
        label-class="visually-hidden">
        <b-form-row>
          <b-col class="label-col" sm="12" md="">
            <label for="voucher-input"><slot name="lblInput">Geben Sie hier die Aufladennummer ein</slot></label>
          </b-col>
          <b-col class="input-col">
            <b-form-input
              id="voucher-input"
              name="voucher"
              type="text"
              required
              v-model="voucherStr"
              @input="$v.voucherStr.$touch"
              :state="isValid('voucherStr')"
              :placeholder="placeholder"
            ></b-form-input>
          </b-col>
          <b-col class="stepper-col">
            <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
              <b-button class="btn-next" type="button" variant="primary" :disabled="$v.$invalid || loading" v-on:click="save">
                <slot name="btnNext">Voucher einlösen</slot>
              </b-button>
            </b-overlay>
          </b-col>
        </b-form-row>
      </b-form-group>
    </b-form>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import isValid from '../../../../../mixins/isValid'
import { mapActions } from 'vuex'
import processSteps from '../../../../../mixins/processSteps'
import { stepName as nextProcessStep } from './ThankYou.vue'
import transaction from '@/mixins/transaction'

export const stepName = 'input'

export default {
  name: 'VoucherInput',
  props: {
    placeholder: {
      type: String,
      default: 'Aufladecode'
    }
  },
  mixins: [
    transaction('voucher'),
    validationMixin,
    isValid,
    processSteps(stepName, stepName, nextProcessStep)
  ],
  data: function () {
    return {
      loading: false,
      voucherStr: ''
    }
  },
  methods: {
    ...mapActions('topUp', [
      'sendVoucher'
    ]),
    reset () {
      this.voucherStr = ''
      this.$v.voucherStr.$reset()
    },
    async save () {
      this.loading = true
      await this.sendVoucher({
        voucher: this.voucherStr,
        nextStep: this.nextStep
      })
      this.loading = false
    }
  },
  validations () {
    return {
      voucherStr: {
        required,
        validateVoucher: (this.$config?.validation?.validateVoucher) || ((voucher) => true)
      }
    }
  }
}
</script>
